import React, { useContext, useEffect } from "react";
import { Paper, useTheme, useMediaQuery } from "@mui/material";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  AsideNavigation,
  FlexContainer,
  RelativeContainer,
} from "../../shared/components/styled/Container.styled";
import { PageTitle } from "../../shared/components/styled/Typography.styled";
import RequireAuth from "../../shared/components/guards/RequireAuth";
import { AuthContext } from "../../contexts/AuthContext";
import { useResponsivePadding } from "../../shared/hooks/useResponsivePadding";
import PageLayout from "../../shared/components/PageLayout";
import HorizontalMobileNavigation from "../../shared/components/HorizontalMobileNavigation";

const UserProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { activeLoanDetails } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { contentContainer } = useResponsivePadding();

  useEffect(() => {
    if (location.pathname === "/profile") {
      navigate("/profile/communication", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const navigationItems = [
    {
      to: "/profile/communication",
      label: "Communication",
    },
    {
      to: "/profile/change-address",
      label: "Change Address",
    },
    {
      to: "/profile/loan",
      label: "Link Account",
    },
    {
      to: "/profile/statement-delivery",
      label: "Change Statement Delivery",
      linkSx: {
        pointerEvents: activeLoanDetails?.loanDetails?.paperless ? "auto" : "none",
        opacity: activeLoanDetails?.loanDetails?.paperless ? 1 : 0.5,
      },
    },
  ];

  return (
    <RequireAuth>
      <RelativeContainer width="100%">
        <PageTitle
          variant="h1"
          component="h1"
          color="primary.dark"
          fontSize="3rem"
          display={isMobile ? "none" : "block"}
          sx={{
            width: {
              md: '100%',
            }
          }}
        >
          Manage My Account
        </PageTitle>
      </RelativeContainer>
      <Paper
        elevation={0}
        sx={{ backgroundColor: { xs: "unset", md: "white" } }}
      >
        <PageLayout>
          <FlexContainer
            justifycontent="space-between"
            alignitems="center"
            width="100%"
            sx={{ marginBottom: isMobile ? "20px" : 0 }}
          >
            <PageTitle
              variant="h1"
              component="h1"
              color="primary.black"
              fontSize="2rem"
              display={isMobile ? "block" : "none"}
              padding="0 !important"
              width="100%"
            >
              Manage My Account
            </PageTitle>
          </FlexContainer>

          <FlexContainer
            alignitems="flex-start"
            sx={{ flexDirection: { xs: "column", md: "row" } }}
          >
            {isMobile ? (
              <HorizontalMobileNavigation
                items={navigationItems}
              />
            ) : (
              <AsideNavigation sx={{ maxWidth: "min-content" }}>
                <Link
                  to="communication"
                  className={
                    location.pathname.includes("/communication") ? "active" : ""
                  }
                >
                  Communication
                </Link>
                <Link
                  to="change-address"
                  className={
                    location.pathname.includes("/change-address") ? "active" : ""
                  }
                >
                  Change Address
                </Link>
                <Link
                  to="loan"
                  className={location.pathname.includes("/loan") ? "active" : ""}
                >
                  Link Account
                </Link>
                <Link
                  to="statement-delivery"
                  className={
                    location.pathname.includes("/statement-delivery")
                      ? "active"
                      : `${activeLoanDetails?.loanDetails?.paperless ? "" : "disabled"}`
                  }
                >
                  Change Statement Delivery
                </Link>
              </AsideNavigation>
            )}
            <FlexContainer padding={contentContainer} width="100%">
              <FlexContainer width="100%" flexdirection="column" gap="25px">
                <Outlet />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </PageLayout>
      </Paper>
    </RequireAuth>
  );
};

export default UserProfile;